export default {"src":"/_next/static/media/ico-klarna.4b99eb08.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};